<template>
	<div class="demand">
		<div class="demand_id">
			<span>{{ id.split("-")[0] }}</span>
		</div>
		<div class="demand_name">
			<span class="fas fa-folder"></span> {{ name }}
		</div>
		<div class="request_on">
			<span class="content_title">Solicitado em: </span>
			<span class="content">{{ `${requestOn.getDate().toString().padStart(2, '0')}/${(requestOn.getMonth() + 1).toString().padStart(2, '0')}/${requestOn.getFullYear()}` }}</span>
		</div>
		<div class="status">
			<span class="content_title">Status: </span>
			<span class="content">{{ status }}</span>
		</div>
		<div class="actions">
			<button>
				<span class="fas fa-eye"></span>
				Visualizar
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DemandItem',
	props: {
		id: { type: String, default: '' },
		name: { type: String, default: '' },
		requestOn: { type: Date, default: '' },
		status: { type: String, default: '' }
	}
}
</script>

<style lang="scss" scoped>
	.demand {
		display: grid;
		align-items: center;
		align-content: center;
		grid-template-columns: .5fr 4fr 1fr 1.5fr 1.5fr;
		padding: 10px 20px;
		border: 2px solid #21344D;
		border-radius: 10px;
		background-color: #061529;
		color: #59708F;
		font-family: 'Roboto Condensed', 'Roboto', sans-serif;
		margin-bottom: 10px;

		body.light & {
			color: #FFF;
		}

		@media all and (max-width: 1600px) {
			grid-template-columns: .5fr 3fr 1.5fr 1.5fr 1.5fr;

			@media all and (max-width: 800px) {
				& {
					display: block;
					text-align: center;

					& .icon {
						display: inline-block;
						margin-right: 10px;
					}

					& .demand_name {
						display: inline-block;
					}
				}
			}
		}

		.demand_id {
			align-items: center;
			text-align: center;

			width: 140px;
			padding: 2px;
			margin-right: 20px;
			border: none;
			border-radius: 20px;
			font-weight: bold;
			background-color: #59708F;
			color: #061529;

			@media all and (max-width: 800px) {
				& {
					display: block;
					margin: 15px;
				}
			}

		}

		.request_on {
			align-items: center;

			.content_title {
				display: block;
				color: #99BCE5;
				font-size: 14px;
				text-align: center;

				@media all and (max-width: 800px) {
					display: inline-block;
					color: unset;
					font-size: unset;
					margin-right: 10px;
				}
			}

			.content {
				display: block;
				margin-top: -5px;
				text-align: center;

				@media all and (max-width: 800px) {
					display: inline-block;
				}
			}
		}

		.status {
			align-items: center;

			.content_title {
				display: block;
				color: #99BCE5;
				font-size: 14px;
				text-align: left;

				@media all and (max-width: 800px) {
					display: inline-block;
					color: unset;
					font-size: unset;
					margin-right: 10px;
				}
			}

			.content {
				display: block;
				margin-top: -5px;
				text-align: left;

				@media all and (max-width: 800px) {
					display: inline-block;
				}
			}
		}

		.actions {
			margin-left: auto;

			@media all and (max-width: 800px) {
				margin: 10px auto 0 auto;
				text-align: center;
			}

			button {
				padding: 8px;
				border: none;
				border-radius: 5px;
				font-weight: bold;
				background-color: #E2E41A;
				color: #06162B;
				text-transform: uppercase;
				cursor: pointer;

				&:hover {
					background-color: #FAFF00;
				}
			}
		}
	}
</style>
